import { Component, OnInit, Input } from '@angular/core';
import { CampaignService } from 'src/app/services/campaign.service';
import { TenantLocalService } from 'src/app/services/tenantlocal.service';
import { Platform } from 'src/app/models/platform';
import { TypeNote } from 'src/app/models/type-note.model';
import { Tier } from 'src/app/models/tier.model';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {

  @Input() results: any;
  @Input() datas: any;

  search: string = '';
  dataSlice: any[] = [];
  data: any[] = [];

  xlabel: number = 1;
  ylabel: number = 1;
  tenantSlug: string | null = null;

  platforms: Platform[] = [];
  typeNotes: TypeNote[] = [];
  tiers: Tier[] = [];

  constructor(
    public campaignService: CampaignService,
    private tenantLocalService: TenantLocalService
  ) { }

  ngOnInit() {
    this.data = this.results.DPRPs;
    this.xlabel = this.results.params.xlabel;
    this.ylabel = this.results.params.ylabel;
    this.dataSlice = this.data.slice(0, 15);
    this.tenantSlug = this.tenantLocalService.getTenantSlug();

    // Las plataformas 
    this.platforms = this.results.params.platforms || [];
    //Tipo de Notas
    this.typeNotes = this.results.params.typeNotes || [];
    //Tier
    this.tiers = this.results.params.tiersData || [];
  }

  getPlatformStyle(idPlataforma: number): { [key: string]: string } {
    const platform = this.platforms.find(p => p.id === idPlataforma);
    if (platform) {
      return {
        'background-color': platform.backgroundColor,
        'color': platform.textColor
      };
    }
    return { 'background-color': '#6c757d', 'color': '#ffffff' };
  }

  getTypeNoteStyle(tipoNota: number): { [key: string]: string } {
    const typeNote = this.typeNotes.find(n => n.id === tipoNota);
    if (typeNote) {
      return {
        'background-color': typeNote.backgroundColor,
        'color': typeNote.textColor
      };
    }
    return { 'background-color': '#6c757d', 'color': '#ffffff' };
  }

  getTierStyle(tipoTier: number): { [key: string]: string } {
    const tier = this.tiers.find(t => t.id === tipoTier);
    if (tier) {
      return {
        'background-color': tier.backgroundColor,
        'color': tier.textColor
      };
    }
    return { 'background-color': '#6c757d', 'color': '#ffffff' };
  }

  onModalScrollDown() {
    if (this.dataSlice.length < this.data.length) {
      let lengthArray = this.dataSlice.length;
      let lengthArrayTwo = this.data.length;
      for (let i = lengthArray; i < lengthArray + 10 && i < lengthArrayTwo; i++) {
        this.dataSlice.push(this.data[i])
      }
    }
  }

  onSearch() {
    if (this.search) {
      const term = this.search.toLowerCase();
      if (this.results.params.campaigns.length > 0) {
        this.data = this.results.DPRPs.filter(r => r.PlanMedio?.toLowerCase().indexOf(term) > -1);
      } else {
        this.data = this.results.DPRPs.filter(r => r.voceros?.toLowerCase().indexOf(term) > -1);
      }
      this.dataSlice = this.data.slice(0, 15);
    } else {
      this.data = this.results.DPRPs;
      this.dataSlice = this.data.slice(0, 15);
    }
  }

}
